import classNames from 'classnames';
import Link from 'next/link';
import Logo from '../Logo';
import PurchaseFlowStepper from '@/components/v2/purchase-flow/PurchaseFlowStepper';
import usePurchaseFlowNav from '@/components/v2/purchase-flow/usePurchaseFlowNav';
import PurchaseFlowMobileRow from '@/components/v2/purchase-flow/PurchaseFlowMobileRow';

const CompactNavbar = () => {
  const purchaseFlow = usePurchaseFlowNav();

  return (
    <>
      <div className="sticky top-0 z-50 flex h-[60px] w-full items-center border-b border-[#F2F2F2] bg-white shadow-[0_6px_8px_-4px_rgba(0,_0,_0,_0.08)] transition-transform duration-300">
        {/* w-full: the bar is a flex row, so the container would otherwise
            shrink to its content and sit centred. On desktop the progress
            bar sits opposite the logo; on mobile it gets its own row below,
            leaving the logo alone and centred. */}
        <div
          className={classNames(
            'reebelo-container flex w-full items-center',
            purchaseFlow
              ? 'justify-center lg:justify-between'
              : 'justify-between',
          )}
        >
          <Link
            href="/"
            prefetch={false}
            aria-label="Link to Home"
            id="icon-home-desktop"
            className="block w-fit scale-[85%] lg:scale-100"
          >
            <Logo />
          </Link>
          {purchaseFlow && (
            <PurchaseFlowStepper
              {...purchaseFlow}
              className="hidden lg:block"
            />
          )}
        </div>
      </div>
      {purchaseFlow && <PurchaseFlowMobileRow {...purchaseFlow} />}
    </>
  );
};

export default CompactNavbar;
